import { WaveForm } from "../../../../../../library-js/audio/visualization/wave-form/WaveForm";
import { WaveformChannelType, WaveformGenerationOptions } from "../../../../../../library-js/audio/visualization/wave-form/WaveFormGenerationOptions";
import { WaveFormRenderer } from "../../../../../../library-js/audio/visualization/wave-form/WaveFormRenderer";
import { AttributeValue } from "../../../../../../library-js/dom-tools/AttributeValue";
import { ElementType } from "../../../../../../library-js/dom-tools/ElementType";
import { OnChange, OnLoad } from "../../../../../../library-js/dom-tools/EventListeners";
import { KeyboardSensorID } from "../../../../../../library-js/sensors/KeyboardSensorID";
import { AppCommand } from "../../../../../../library-js/web-app/commands/AppCommand";
import { AppCommandBinding } from "../../../../../../library-js/web-app/commands/AppCommandBinding";
import { AppCommandBindingEntry } from "../../../../../../library-js/web-app/commands/AppCommandBindingEntry";
import { AppCommandContext } from "../../../../../../library-js/web-app/commands/AppCommandContext";
import { AudioEditor } from "../../AudioEditor";
import { ClipCreator } from "../../project/exporting/ClipCreator";

export class SliceClips extends AppCommand
{
  initialize()
  {
    this._name = 
    {
      en: "Slice Clips",
      de: "Clips slicen" 
    }

    this._info = 
    {
      en: "Generates the audio clips that will be exported.",
      de: "Erstellt die Audio-Clips, die exportiert werden."
    }

    this._shortCutEntries = 
    [
      AppCommandBindingEntry.forDesktop( AppCommandBinding.primaryWith( KeyboardSensorID.Key_E ) )
    ]
  }

  async _execute( commandContext:AppCommandContext<any,any> ):Promise<void>
  {
    let app = commandContext.webApp as AudioEditor;

    let promise = new Promise<void>(
      async ( resolve, reject )=>
      {
        console.log( "Exporting" );
        let exporter = new ClipCreator();
        exporter.editor = app;
        exporter.settings = app.project.exportSettings;

        await exporter.generateExportClips();

        resolve();
      }
    );

    return Promise.resolve( promise );
  }
}